import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterFuelTypeIdsSearchValueObject extends ValueObject {
  #fuelTypeIds

  constructor({fuelTypeIds}) {
    super()
    this.#fuelTypeIds = fuelTypeIds
  }

  static create({fuelTypeIds}) {
    return new FilterFuelTypeIdsSearchValueObject({
      fuelTypeIds: FilterIdsArraySearchValueObject.create({value: fuelTypeIds})
    })
  }

  static validate({fuelTypeIds}) {
    if (fuelTypeIds === null || fuelTypeIds === undefined) {
      throw new InvalidParamsSharedError('Fuel type ids is required')
    }
  }

  static createNonEmpty({fuelTypeIds}) {
    FilterFuelTypeIdsSearchValueObject.validate({fuelTypeIds})
    return new FilterFuelTypeIdsSearchValueObject({
      fuelTypeIds: FilterIdsArraySearchValueObject.createForNumbers({value: fuelTypeIds})
    })
  }

  static createWithDefaultValue({config, fuelTypeIds}) {
    const {DEFAULT_FUEL_TYPE_IDS_SEARCH} = config.get('searchFilters')

    return new FilterFuelTypeIdsSearchValueObject({
      fuelTypeIds: FilterIdsArraySearchValueObject.createForNumbers({
        value: fuelTypeIds ?? DEFAULT_FUEL_TYPE_IDS_SEARCH
      })
    })
  }

  static createQueryParams({config, fuelTypeIds}) {
    const {DEFAULT_FUEL_TYPE_IDS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterFuelTypeIdsSearchValueObject({
      fuelTypeIds: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.FUEL_TYPE],
        value: fuelTypeIds ?? DEFAULT_FUEL_TYPE_IDS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#fuelTypeIds.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#fuelTypeIds.queryParam})
    }
  }

  get value() {
    return this.#fuelTypeIds.value
  }

  toJSON() {
    return {
      fuelTypeIds: this.#fuelTypeIds.toJSON()
    }
  }
}
